import { useEffect, useState } from "react";

export const useMediaQuery = (query: string): boolean => {
  const [[mql, matches], setState] = useState<[MediaQueryList | null, boolean]>(
    () => {
      if (typeof window === "undefined") return [null, false];
      const m = window.matchMedia(query);
      return [m, m.matches];
    },
  );

  useEffect(() => {
    const m = mql ?? window.matchMedia(query);
    const handler = (e: MediaQueryListEvent): void => setState([m, e.matches]);
    m.addEventListener("change", handler);
    return () => m.removeEventListener("change", handler);
  }, [query, mql]);

  return matches;
};
